module.exports = __webpack_public_path__ + "static/media/slider_2_es_sm.60d884e6.svg";